import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { PfeConfigurationService } from '../pfe-config-service/config-service.service';
import { PageConfig } from '../../models/ngx-pfe-page-config.model';

export const pfePageConfigResolver: ResolveFn<PageConfig | undefined> = (
  activatedRoute: ActivatedRouteSnapshot
): Promise<PageConfig | undefined> => {
  const pfeConfigService = inject(PfeConfigurationService);

  if (activatedRoute?.routeConfig?.path) {
    return pfeConfigService.getPageConfiguration(activatedRoute.routeConfig.path);
  } else {
    return Promise.resolve(undefined);
  }
};
